// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Board.css')));

var component = ReasonReact.statelessComponent("Board");

function renderCell(cell) {
  var c;
  if (cell) {
    switch (cell[0]) {
      case 0 : 
          c = "I";
          break;
      case 1 : 
          c = "J";
          break;
      case 2 : 
          c = "L";
          break;
      case 3 : 
          c = "O";
          break;
      case 4 : 
          c = "S";
          break;
      case 5 : 
          c = "T";
          break;
      case 6 : 
          c = "Z";
          break;
      
    }
  } else {
    c = "blank";
  }
  return React.createElement("div", {
              className: "cell cell-" + (String(c) + "")
            });
}

function make(board, className, isPaused, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: className
                }, $$Array.of_list(List.map((function (cell) {
                            if (isPaused !== 0) {
                              return React.createElement("div", {
                                          className: "cell cell-paused"
                                        });
                            } else {
                              return renderCell(cell);
                            }
                          }), List.flatten(List.rev(board)))));
    });
  return newrecord;
}

exports.component  = component;
exports.renderCell = renderCell;
exports.make       = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Board.re
// module id = 38
// module chunks = 0